import { useEffect, useRef, useState } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router';
import { useApp } from '../data/AppProvider';
import { errorMessage } from '../data/hooks';
import { Notice, Spinner } from '../components/ui';
import { safeNext } from '../lib/safeNext';

/**
 * The sign-in email links here with a token hash. Verifying it needs nothing stored in this browser,
 * so the link works on any device or in a mail app's built-in browser.
 */
export function AuthConfirmScreen() {
  const { data, session } = useApp();
  const [params] = useSearchParams();
  const tokenHash = params.get('token_hash');
  const rawType = params.get('type');
  const type = rawType === 'magiclink' || rawType === 'signup' ? rawType : 'email';
  const next = safeNext(params.get('next'), window.location.origin);
  const [error, setError] = useState<string | null>(tokenHash ? null : 'This sign-in link is incomplete. Send yourself a new one.');
  const started = useRef(false);

  useEffect(() => {
    if (!tokenHash || started.current || session) return;
    started.current = true;
    data.verifyEmailLink(tokenHash, type).catch((e) => setError(errorMessage(e)));
  }, [data, tokenHash, type, session]);

  if (session) return <Navigate to={next} replace />;

  return (
    <main className="safe-top flex min-h-dvh flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        {error ? (
          <Notice tone="warn" title="Couldn’t sign you in">
            {error} <Link to={`/sign-in?next=${encodeURIComponent(next)}`} className="underline">Back to sign-in</Link>
          </Notice>
        ) : (
          <Spinner label="Signing you in" />
        )}
      </div>
    </main>
  );
}
